import {reactive} from "vue";

export interface Feature {
    clientVersion?: number;
    nodePlayerVersion?: string;
    flvjsPlayerVersion?: string;
    androidForbid?: boolean;
    virtualUser?: boolean;
    film?: boolean;
    earlyFinishForbid?: boolean;
    schoolContent?: boolean;
    talkerSideLayout?: boolean;
    chatExport?: boolean;
}

export const feature = reactive<Feature>({
    clientVersion: undefined,
    nodePlayerVersion: undefined,
    flvjsPlayerVersion: undefined,
    androidForbid: false,
    virtualUser: false,
    film: false,
    earlyFinishForbid: false,
    schoolContent: false,
    /** @desc 侧边栏显示连麦学员 */
    talkerSideLayout: false,
    /** @desc 可导出聊天记录 */
    chatExport: false,
});

export const initFeature = (config: Partial<Feature>): void => {
    Object.assign(feature, config);
}
